import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import { withDefaults, ref, onMounted } from "vue";
import { DialogHandler } from "../../../components/dialog/DialogHandler";
import { SessionMemory } from "../../../utils/SessionMemory";
interface Prop {
  assetPath: string;
  thumbnail: string;
  type: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CardThumbnail',
  props: {
    assetPath: null,
    thumbnail: { default: "" },
    type: null
  },
  setup(__props: any) {

const props = __props as { assetPath: string, thumbnail: string, type: string };



const thumbnail = ref("");

const showThumbnailEditor = (path: string) => {
  // console.log("showThumbnailEditor");
  SessionMemory.instance.thumbnailEditTarget = path;
  DialogHandler.showThumbnailEditorDialog();
};

onMounted(() => {
  console.log("mounted " + props.type ,props.assetPath)
  if (props.thumbnail.length > 0) {
    thumbnail.value = props.thumbnail;
  } else if (props.type === "image") {
    thumbnail.value = props.assetPath;
  } else if (props.type === "model") {
    thumbnail.value = "/public/ui/cubes-solid.svg";
  } else if (props.type === "other") {
    thumbnail.value = "/public/ui/file-alt-regular.svg";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (['image', 'other'].includes(__props.type))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "card-img-top img-responsive w-100",
          style: {"height":"12rem","object-fit":"cover"},
          src: thumbnail.value,
          onerror: "this.src='/public/list_back_noimage.png'",
          lazyload: ""
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (['model'].includes(__props.type))
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "card-img-top img-responsive w-100",
          style: {"height":"12rem","object-fit":"cover"},
          src: thumbnail.value,
          onerror: "this.src='/public/list_back_noimage.png'",
          lazyload: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showThumbnailEditor(__props.assetPath)))
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.type === 'movie')
      ? (_openBlock(), _createElementBlock("video", {
          key: 2,
          controls: "",
          class: "card-img-top img-responsive",
          src: __props.assetPath,
          style: {"height":"12rem","object-fit":"cover"},
          lazyload: ""
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (__props.type === 'sound')
      ? (_openBlock(), _createElementBlock("audio", {
          key: 3,
          controls: "",
          class: "card-img-top img-responsive",
          src: __props.assetPath,
          style: {"height":"12rem","object-fit":"cover"},
          lazyload: ""
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})